import React, { useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './HeroNew.css';

const Hero = () => {
  const { t } = useLanguage();
  const timeoutRef = useRef(null);
  const isTypingRef = useRef(false);

  useEffect(() => {
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    const textElement = document.querySelector('.header-logo-desc p');
    if (textElement && t.hero.sloganSuffix) {
      const text = t.hero.sloganSuffix;
      let index = 0;
      textElement.textContent = '';
      isTypingRef.current = true;

      const typeWriter = () => {
        if (index < text.length && isTypingRef.current) {
          textElement.textContent = text.substring(0, index + 1);
          index++;
          timeoutRef.current = setTimeout(typeWriter, 100);
        }
      };

      timeoutRef.current = setTimeout(typeWriter, 1000);
    }

    // Cleanup function
    return () => {
      isTypingRef.current = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [t.hero.sloganSuffix]);

  return (
    <div id="header-wrapper">
      <div className="fenix-head">
        <div className="fenix-sub-head row">
          <div className="header-text">
            <p>{t.hero.welcome}</p>
          </div>

          <div style={{ clear: 'both' }} />

          <div className="header-logo-desc">
            <div className="type">
              <span>{t.hero.sloganPrefix}</span>
              <p></p>
            </div>
          </div>

          <div style={{ clear: 'both' }} />

          <div className="social-head">
            <div className="top-bar-social blue">
              <ul id="social">
                <li>
                  <a className="facebook" href="https://www.facebook.com/dr.adhamelsharkaawy/"
                     title="facebook" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a className="youtube" href="https://www.youtube.com/@adhamelsharkaawy"
                     title="youtube" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-youtube"></i>
                  </a>
                </li>
                <li>
                  <a className="twitter" href="https://twitter.com/dradhambis"
                     title="twitter" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a className="instagram" href="https://www.instagram.com/dr.adhamelsharkawy/"
                     title="instagram" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a className="whatsapp" href="https://wa.me/+201004449782/"
                     title="WhatsApp" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-whatsapp"></i>
                  </a>
                </li>
                <li>
                  <a className="linkedin" href="https://www.linkedin.com/in/dr-adhamelsharkawy?utm_source=share_via&utm_content=profile&utm_medium=member_android"
                     title="LinkedIn" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="slide-in wow bounceInUp" data-wow-delay="1s" data-wow-duration="1s">
            <a className="pointer" href="#section-2">
              <div className="scroll-indicator"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
